var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_6_22602)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint1_linear_6_22602)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9238 19.3898C34.9238 20.1521 34.3 20.7763 33.5373 20.7763H26.6046C26.48 20.7763 26.369 20.7628 26.258 20.7208C26.1885 20.7208 26.1334 20.6931 26.0637 20.6653C25.8975 20.5963 25.7448 20.4988 25.6202 20.3742C25.4953 20.2496 25.3981 20.0966 25.3291 19.9308C25.3013 19.8611 25.2736 19.8056 25.2736 19.7365C25.2319 19.6254 25.2181 19.5144 25.2181 19.3899V12.4571C25.2181 11.6948 25.8419 11.0706 26.6046 11.0706C27.3673 11.0706 27.9911 11.6948 27.9911 12.4571V16.0345L32.5529 11.4727C33.0935 10.9318 33.9811 10.9318 34.5217 11.4727C35.0626 12.0136 35.0626 12.9005 34.5217 13.4415L29.9599 18.0033H33.5373C34.3 18.0033 34.9238 18.6275 34.9238 19.3898Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7379 11.0231C17.7083 11.139 18.5573 11.6845 19.0627 12.527L20.8373 15.4932L20.8388 15.4958C21.2532 16.1838 21.1479 17.0754 20.5639 17.6503L18.0439 20.1885L18.4348 20.853C20.0469 23.5935 22.3733 25.9186 25.1374 27.5567L25.8029 27.9511L28.3345 25.4372L28.3423 25.4293C28.9178 24.8449 29.8095 24.7399 30.4967 25.1541L33.4659 26.9297L33.4669 26.9303C34.3087 27.4357 34.8541 28.2848 34.97 29.2556L34.9714 29.2666C35.0965 30.2241 34.7664 31.1802 34.0754 31.8839L31.889 34.0565L31.8866 34.0588C31.2721 34.6735 30.4822 35 29.7097 35L29.6848 35L29.6608 34.9998C29.6488 34.9997 29.6418 34.9995 29.638 34.9993L29.5895 34.991L29.535 34.9876C19.5848 34.3806 11.6121 26.408 11.0052 16.4585C10.9541 15.622 11.2802 14.7608 11.9343 14.1069L14.1093 11.9178C14.8071 11.2329 15.7651 10.9069 16.7379 11.0231Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_22602",
    x1: 23,
    y1: 26.895,
    x2: 23,
    y2: 0.992272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050D42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_22602",
    x1: 0,
    y1: 23,
    x2: 46,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.af67b9a4335ad9053fd4044cb678dd59.svg";
export { ForwardRef as ReactComponent };